import { Link } from "react-router-dom";
import { useCompare } from "@/context/CompareContext";
import { X, GitCompareArrows } from "lucide-react";

export default function CompareDrawer() {
  const { items, remove, clear } = useCompare();
  if (items.length === 0) return null;
  return (
    <div className="fixed bottom-4 right-4 z-40 bg-ivory border border-bronze shadow-2xl w-[92vw] max-w-md" data-testid="compare-drawer">
      <div className="flex items-center justify-between px-5 py-3 border-b border-ivory-400 bg-ivory-100">
        <div className="flex items-center gap-2">
          <GitCompareArrows className="w-4 h-4 text-copper" />
          <span className="text-xs uppercase tracking-[0.22em] text-bronze">Compare · {items.length}/3</span>
        </div>
        <button onClick={clear} className="text-[10px] uppercase tracking-wider text-ink-100 hover:text-terracotta">Clear</button>
      </div>
      <div className="p-3 space-y-2">
        {items.map((l) => (
          <div key={l.id} className="flex items-center gap-3 border border-ivory-400 p-2">
            <img src={l.images?.[0]} alt="" className="w-14 h-11 object-cover" />
            <div className="flex-1 min-w-0">
              <div className="text-xs font-serif text-ink truncate">{l.title}</div>
              <div className="text-[10px] text-ink-100 uppercase tracking-wider">${(l.price || 0).toLocaleString()}</div>
            </div>
            <button onClick={() => remove(l.id)} className="text-ink-100 hover:text-terracotta"><X className="w-3.5 h-3.5" /></button>
          </div>
        ))}
      </div>
      <div className="p-3 border-t border-ivory-400">
        <Link to="/compare" className="btn-primary w-full !py-2.5 text-xs" data-testid="compare-open">
          Compare Side-by-Side
        </Link>
      </div>
    </div>
  );
}
